export enum Ombre {
    Ouvert,
    SemiOuvert,
    Ferme
}
